import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IOpenAddonsModalActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/OpenAddonsModalActionParams";


export class OpenAddonsModalAction extends BaseAction<IDefaultActionResult, IOpenAddonsModalActionParams> {

    override async run(): Promise<IDefaultActionResult | null> {
        const actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const { isModalOpen } = this.params!
            updateRecoilState("showAddonsModalAtom", isModalOpen)
            actionResult.status = "success"
        } catch (error: any) {
            actionResult.message = error.message
        } finally {
            return actionResult
        }
    }
}

export const openAddonsModalAction = new OpenAddonsModalAction(); 